<template>
  <div>
    <b-form inline class="" @submit="searchCoreQuestions">
      <b-select class="custom-select mr-sm-2 mb-2 mb-sm-0" v-model="tag_id" value="Choose..." :options=tagSelect />
      <b-btn type="submit" variant="primary">{{ $t('search')}}</b-btn>
        <b-btn v-on:click="resetSearch" variant="default" class="ml-1"><i class="ion ion-md-close"></i></b-btn>
  </b-form>
  </div>
</template>
<script>
import {
    ADMIN_GET_TAGS_REQUEST, ADMIN_GET_QUESTIONS_REQUEST
  } from '../_store/administration/questionnary/actiontypes'
  export default {
    props: {
      source: {
        type: String,
        required: true
      },
    },
    mounted() {
        this.$store.dispatch(ADMIN_GET_TAGS_REQUEST)
        .then(response => {
            this.tagSelect = response.data.tags.map(tag => {
              if (this.$cookie.get('language') === 'fr'){
                return {
                  "value": tag.id,
                  "text": tag.label
                }
              } else {
                return {
                  "value": tag.id,
                  "text": tag.label_en
                }
              }
          });
            this.tagSelect.unshift({
              value: 0,
              text: this.$t('themes')
            })
        })
    },
    data() {
      return {
        typeData: [
          {
            value: '',
            text: 'Type de question'
          },
          {
            value: 'TFREE',
            text: 'Réponse libre'
          }, {
            value: 'TSING',
            text: 'Choix Simple'
          }, {
            value: 'TMULT',
            text: 'Choix Multiple'
          }
        ],
        tagSelect: [],
        tag_id: 0,
        question: '',
        type: '',
      }
    },
    methods: {
        resetSearch(){
            this.question = '';
            this.tag_id = 0;
            this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {source: this.source});
        },
       searchCoreQuestions: function (e) {
        e.preventDefault();
        this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {tag_id:this.tag_id, type:this.type, question: this.question, source: this.source})
      },
    }
  }
</script>
<style>
</style>
